"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, chakra } from "@chakra-ui/react";
import React, { useRef } from "react";
import { useCalendarCell } from "react-aria";
const DayButton = chakra("button");
export const CalendarCell = React.memo(function CalendarCell({ datePickerState, calendarState, date, colorPalette, }) {
    const ref = useRef(null);
    const { cellProps, buttonProps, isSelected, isOutsideVisibleRange, isDisabled, formattedDate, } = useCalendarCell({ date }, calendarState, ref);
    const isOutsideMonth = date.month !== calendarState.visibleRange.start.month;
    // Create a custom onClick that updates both states and closes the picker
    const handleClick = () => {
        if (!isDisabled) {
            calendarState.setValue(date);
            datePickerState.setValue(date);
            datePickerState.setOpen(false);
        }
    };
    return (_jsx(Box, { display: "flex", alignItems: "center", justifyContent: "center", colorPalette: colorPalette, ...cellProps, children: _jsx(DayButton, { type: "button", ...buttonProps, disabled: isDisabled, ref: ref, hidden: isOutsideVisibleRange, w: 8, h: 8, rounded: "full", bg: isSelected ? "colorPalette.solid" : "transparent", color: isSelected
                ? "colorPalette.contrast"
                : isOutsideMonth || isDisabled
                    ? "fg.disabled"
                    : "fg", border: "none", cursor: isDisabled ? "not-allowed" : "pointer", fontSize: "14px", fontWeight: "500", display: "flex", alignItems: "center", justifyContent: "center", _hover: !isDisabled && !isSelected
                ? {
                    bg: "bg.subtle",
                }
                : {}, _active: !isDisabled
                ? {
                    bg: "bg.emphasized",
                }
                : {}, onClick: handleClick, children: formattedDate }) }));
});
